import { FC } from 'react';
import { Container, SimpleGrid, Skeleton, Stack, Box } from '@mantine/core';

interface MenuSkeletonProps {
  itemsCount?: number;
}

export const MenuSkeleton: FC<MenuSkeletonProps> = ({ itemsCount = 12 }) => {
  return (
    <Container size="xl" py="xl">
      <Stack gap="md" mb="xl" ta="center">
        <Skeleton height={50} width="60%" mx="auto" />
        <Skeleton height={20} width="40%" mx="auto" />
      </Stack>

      <Box mb="xl">
        <Skeleton height={56} radius="md" />
        <Box mt="sm">
          <Skeleton height={36} width="30%" />
        </Box>
      </Box>

      <Box mb="xl">
        <Skeleton height={24} width="20%" mb="sm" />
        <SimpleGrid cols={{ base: 4, sm: 6, md: 8 }} spacing="sm">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <Stack key={i} align="center" gap={8}>
              <Skeleton circle height={48} width={48} />
              <Skeleton height={16} width={60} />
              <Skeleton height={20} width={40} />
            </Stack>
          ))}
        </SimpleGrid>
      </Box>

      <Skeleton height={2} width={60} mx="auto" mb="lg" />

      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
        {Array(itemsCount).fill(0).map((_, i) => (
          <Box key={i} style={{ height: '100%' }}>
            <Skeleton height={200} radius="md" />
            <Stack gap="xs" p="md">
              <Skeleton height={24} width="70%" />
              <Skeleton height={28} width="30%" />
              <Skeleton height={40} width="90%" />
            </Stack>
          </Box>
        ))}
      </SimpleGrid>
    </Container>
  );
};